import { rem } from 'polished';
import styled from 'styled-components';

const UseToolsHorizontalScrollList = styled.ul`
    display: flex;
    list-style: none;
    margin: ${rem(8)} 0 ${rem(16)};
    padding: 0;
`;

export default UseToolsHorizontalScrollList;
